/*
 * @Author: 李朋飞
 * @Date: 2021-07-15 19:02:55
 * @LastEditTime: 2021-09-06 10:33:59
 * @Description: 放置vuex公共数据的位置， 相当于vue文件内的data
 * 
 */

const state = {
  menuList: null,
  routerListNew: null,
  myInfo: '',
  userId: '',
  chat_unread: '',
  conversationList: [],
  historyMessage: [],
  newMessages: [],
  userIsTyping: '',
  msgReceipts: '',
  chatNotionMsg: null, // 消息通知
  deleteUserId: ""
};

export default state;


// WEBPACK FOOTER //
// ./src/store/state.js